/**
 * Legacy onboarding backfill (Firestore). Pure rules live in `onboardingAccountState.ts`.
 */

export {
  ONBOARDING_V1_RELEASED_AT,
  isLegacyUser,
  hasExistingProfile,
  shouldBypassOnboarding,
  isOnboardingCompleted,
  shouldTreatAsOnboardingComplete,
  needsBackfill,
  hasSelectableRoleSet,
} from './onboardingAccountState';

import { doc, getDoc, setDoc, serverTimestamp } from 'firebase/firestore';
import { db } from './firebase';

/**
 * Idempotent backfill: set onboardingCompleted, onboardingVersion, onboardingCompletedAt (and onboardingStatus)
 * on users/{uid} only when not already completed.
 */
export async function backfillOnboardingCompleted(uid: string): Promise<void> {
  if (!uid) return;
  const ref = doc(db, 'users', uid);
  const snap = await getDoc(ref);
  const data = snap.exists() ? snap.data() : null;
  if (data?.onboardingCompleted === true || data?.onboardingStatus === 'completed') {
    return;
  }
  await setDoc(
    ref,
    {
      onboardingCompleted: true,
      onboardingVersion: 1,
      onboardingCompletedAt: serverTimestamp(),
      onboardingStatus: 'completed',
      updatedAt: serverTimestamp(),
    },
    { merge: true },
  );
  if (process.env.NODE_ENV === 'development') {
    // eslint-disable-next-line no-console
    console.log('[onboarding-legacy] Backfilled onboarding completed for legacy/existing user:', uid);
  }
}
